<template>
  <v-dialog content-class="radius-20" v-model="showDialog" max-width="1200">
    <v-card class="py-4" :dir="currentDir">
      <v-card-title class="d-flex justify-space-between">
        <h2 class="my-2 grey--text text--darken-2">
          {{ $t("label.previewItem") }}
        </h2>

        <div>
          <v-btn
            v-if="canEdit"
            text
            class="mx-2"
            color="primary"
            :loading="loading"
            :disabled="loading"
            @click="editSCMItem"
          >
            <v-icon :title="$t('button.edit')" class="edit-icon">
              mdi-pencil
            </v-icon>

            <span class="mx-3"> {{ $t("button.edit") }} </span>
          </v-btn>

          <v-btn
            v-if="canDelete"
            text
            class="mx-2"
            color="error"
            :loading="loading"
            :disabled="loading"
            @click="deleteSCMItem"
          >
            <v-icon :title="$t('button.delete')" class="delete-icon">
              mdi-delete
            </v-icon>

            <span class="mx-3"> {{ $t("button.delete") }} </span>
          </v-btn>
        </div>
      </v-card-title>

      <v-card-text class="py-0">
        <v-container>
          <v-row>
            <v-col cols="12">
              <h3 class="grey--text text--darken-2 special-font-size--title">
                {{ $t("label.itemInfo") }}
              </h3>
            </v-col>

            <v-col class="d-flex justify-space-between" cols="12" sm="4">
              <div class="grey--text special-font-size--text">
                {{ $t("label.itemCode") }}
              </div>
              <div class="grey--text text--darken-4 special-font-size--text">
                {{ scmItemPreviewData.code || "-" }}
              </div>
            </v-col>

            <v-col class="d-flex" cols="12" sm="8">
              <div class="grey--text special-font-size--text">
                {{ $t("label.name") }}
              </div>
              <div
                class="grey--text text--darken-4 mx-8 special-font-size--text"
              >
                {{ scmItemPreviewData.name || "-" }}
              </div>
            </v-col>

            <v-col class="d-flex justify-space-between" cols="12" sm="4">
              <div class="grey--text special-font-size--text">
                {{ $t("label.category") }}
              </div>
              <div class="grey--text text--darken-4 special-font-size--text">
                {{
                  (scmItemPreviewData.category &&
                    scmItemPreviewData.category.name) ||
                    "-"
                }}
              </div>
            </v-col>

            <v-col class="d-flex justify-space-between" cols="12" sm="4">
              <div class="grey--text special-font-size--text">
                {{ $t("label.subCategory") }}
              </div>
              <div class="grey--text text--darken-4 special-font-size--text">
                {{
                  (scmItemPreviewData.sub_category &&
                    scmItemPreviewData.sub_category.name) ||
                    "-"
                }}
              </div>
            </v-col>

            <v-col class="d-flex justify-space-between" cols="12" sm="4">
              <div class="grey--text special-font-size--text">
                {{ $t("label.active") }}
              </div>
              <v-chip v-if="scmItemPreviewData.active" color="success">
                {{ $t("label.yes") }}
              </v-chip>
              <v-chip v-else color="error"> {{ $t("label.no") }} </v-chip>
            </v-col>

            <v-col cols="12">
              <h3 class="grey--text text--darken-2 special-font-size--title">
                {{ $t("label.itemQuantity") }}
              </h3>
            </v-col>

            <v-col class="d-flex justify-space-between" cols="12" sm="4">
              <div class="grey--text special-font-size--text">
                {{ $t("label.yearlyNeed") }}
              </div>
              <div class="grey--text text--darken-4 special-font-size--text">
                {{ scmItemPreviewData.yearly_needed_qty }}
              </div>
            </v-col>

            <v-col class="d-flex justify-space-between" cols="12" sm="4">
              <div class="grey--text special-font-size--text">
                {{ $t("label.safetyPercent") }}
              </div>
              <div class="grey--text text--darken-4 special-font-size--text">
                {{ scmItemPreviewData.percent_of_safty_stock }}
              </div>
            </v-col>

            <v-col class="d-flex justify-space-between" cols="12" sm="4">
              <div class="grey--text special-font-size--text">
                {{ $t("label.amountOfPurchace") }}
              </div>
              <div class="grey--text text--darken-4 special-font-size--text">
                {{ scmItemPreviewData.amount_of_purchase }}
              </div>
            </v-col>

            <v-col class="d-flex justify-space-between" cols="12" sm="4">
              <div class="grey--text special-font-size--text">
                {{ $t("label.maxStock") }}
              </div>
              <div class="grey--text text--darken-4 special-font-size--text">
                {{ scmItemPreviewData.max_stock }}
              </div>
            </v-col>

            <v-col class="d-flex justify-space-between" cols="12" sm="4">
              <div class="grey--text special-font-size--text">
                {{ $t("label.minStock") }}
              </div>
              <div class="grey--text text--darken-4 special-font-size--text">
                {{ scmItemPreviewData.min_stock }}
              </div>
            </v-col>

            <v-col class="d-flex justify-space-between" cols="12" sm="4">
              <div class="grey--text special-font-size--text">
                {{ $t("label.waitingDays") }}
              </div>
              <div class="grey--text text--darken-4 special-font-size--text">
                {{ scmItemPreviewData.waiting_days }}
              </div>
            </v-col>

            <v-col class="d-flex justify-space-between" cols="12" sm="4">
              <div class="grey--text special-font-size--text">
                {{ $t("label.primaryUOM") }}
              </div>
              <div class="grey--text text--darken-4 special-font-size--text">
                {{
                  (scmItemPreviewData.unit_of_measure &&
                    scmItemPreviewData.unit_of_measure.name) ||
                    "-"
                }}
              </div>
            </v-col>

            <v-col class="d-flex justify-space-between" cols="12" sm="4">
              <div class="grey--text special-font-size--text">
                {{ $t("label.reorderQty") }}
              </div>
              <div class="grey--text text--darken-4 special-font-size--text">
                {{ scmItemPreviewData.reorder_qty }}
              </div>
            </v-col>

            <v-col class="d-flex justify-space-between" cols="12" sm="4">
              <div class="grey--text special-font-size--text">
                {{ $t("label.lastUnitPrice") }}
              </div>
              <div class="grey--text text--darken-4 special-font-size--text">
                {{ scmItemPreviewData.last_unit_price }}
              </div>
            </v-col>

            <v-col v-if="scmItemPreviewData.notes" cols="12">
              <div class="grey--text special-font-size--text">
                {{ $t("label.notes") }}
              </div>
              <p class="mt-2 grey--text text--darken-4 special-font-size--text">
                {{ scmItemPreviewData.notes }}
              </p>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import i18n from "@/lang";

export default {
  name: "SCMItemPreviewDialogComponent",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    scmItemPreviewData: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    canEdit: {
      type: Boolean,
      required: true
    },
    canDelete: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    showDialog: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit("input", newValue);
      }
    },
    currentLocale() {
      return i18n.locale;
    },
    currentDir() {
      return this.currentLocale === "ar" ? "rtl" : "ltr";
    }
  },
  methods: {
    editSCMItem() {
      this.$emit("edit", this.scmItemPreviewData.id);
    },
    deleteSCMItem() {
      this.$emit("delete", this.scmItemPreviewData.id);
    }
  }
};
</script>

<style lang="scss" scoped>
.special-font-size {
  &--title {
    font-size: 1.5em !important;
  }
  &--text {
    font-size: 1.1em !important;
  }
}
</style>
